<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">
    <div class="layout-column flex ma-2"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">
      <div v-bind:style="{'z-index': '4'}" class="layout-row layout-align-center-center pa-2">
        <div class="layout-row">
          <lx-btn small classes="mr-1" :disabled="false"
                  @click="getDataForTable()"
                  icon="refresh" tooltip="Ansicht aktualisieren" label="Aktualisieren"
                  :hide-label="true"></lx-btn>
        </div>

        <div class="flex layout-row layout-align-center-center pt-2">
          <label style="font-size: 16px;" :style="{color: compColor.primeColor}" class="mx-3"
          >Meldungen im Zeitraum von:</label>

          <validation-provider tag="div"
                               ref="startDate"
                               name="startDate"
                               :rules="{german_date:true, date_not_in_future: true, date_must_be_lesser_than: endDate}"
                               v-slot="{ errors }">
            <lx-datepicker
              :color="compColor.primeColor"
              :dark="compColor.isInDarkMode"
              v-model="startDate"
              name="startDate"
              class="ml-3"
              :dense="true"
              outlined
              :hide-details="!errors || errors.length <= 0"
              :error="errors[0]">
            </lx-datepicker>
          </validation-provider>

          <label style="font-size: 16px;" class="mx-3" :style="{color: compColor.primeColor}">bis:</label>

          <validation-provider tag="div"
                               ref="endDate"
                               name="endDate"
                               :rules="{german_date:true, date_must_be_greater_than: startDate}"
                               v-slot="{ errors }">
            <lx-datepicker
              :color="compColor.primeColor"
              :dark="compColor.isInDarkMode"
              v-model="endDate"
              dense
              name="endDate"
              :hide-details="!errors || errors.length <= 0"
              :error="errors[0]">
            </lx-datepicker>
          </validation-provider>

          <div class="layout-row ml-5" style="font-size: 16px;">
            <span class="pr-1" :style="{color: compColor.primeColor}">{{ !startDate && !endDate ? $t('STATISTICS.OVERALL') : $t('STATISTICS.TIME_PERIOD') }}</span>
            <span v-show="reports"
                  :style="{color: compColor.primeColor}"
            >{{ setHeaderMessage() }}</span>
            <span v-show="!reports" :style="{color: compColor.primeColor}">{{ $t('STATISTICS.TEXT_PART_EMPTY') }}</span>
          </div>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="flex layout-column lx-delivery-background pa-1" style="overflow-y: hidden">
        <div class="elevation-3 flex layout-column pa-1" style="border-radius: 6px;" :style="{'background': compColor.lxExpansion.background}">
          <div style="border-radius: 6px;border: 1px solid rgba(0,0,0,0.1);" class="flex layout-column" ref="Statistics">
            <lx-data-table
              tableName="Statistics"
              v-model="tableObj.selection"
              :items="statisticItems"
              :headers="tableObj.headers"
              :loading="tableObj.loading"
              :hideContextFilter="true"
              :tableOptions="tableObj.options"
              @changeOptions="changeTableOptions"
            >

              <!-- set masterdetail-view with a fix height of half fo window-height -->
              <template v-slot:masterdetail="{ item }">
                <div class="py-4 px-6" :style="{'max-width': windowW + 'px !important'}">
                  <div style="overflow-y: auto;" :style="{'max-height': windowH/2 + 'px !important'}">
                    <statistics-list :location-id="item.locationId" :start-date="startDate" :end-date="endDate" :datesAreInvalid="datesAreInvalid"></statistics-list>
                  </div>
                </div>
              </template>
            </lx-data-table>
          </div>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="layout-row pa-0">
        <lx-pagination :page-name="'Statistics'"
                       :page-options="pagingOptions"
                       :page-change="getDataForTable"></lx-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import LxPagination from '../../components/lx_pagination/LxPagination'
import StatisticsList from './StatisticsList'

export default {
  name: 'Statistics',
  data () {
    return {
      windowW: window.innerWidth,
      windowH: window.innerHeight,
      statisticItems: [],

      selectedListEntry: null,
      listSelectionList: [],

      startDate: null,
      endDate: null,
      reports: null,
      patients: null,
      reportedForms: null,
      datesAreInvalid: false,
      pagingOptions: {
        limit: 50,
        skip: 0,
        count: 0
      },
      tableObj: {
        loading: false, // benutzt während des GetDatas um eine Ladeanimation einzublenden
        options: {
          sortBy: ['physician.lastname'],
          sortDesc: [false],
          getClassForItem: (row) => {
            if (row.isExpanded) {
              return 'row-bold'
            }
            return ''
          }
        },
        selection: null,
        headers: [
          {
            text: this.$t('LIST_DIVERSE.LASTNAME_PHYSICIAN'),
            value: 'physician.lastname',
            width: '300px',
            sortable: true,
            filterable: true
          },
          {
            text: this.$t('LIST_DIVERSE.FIRSTNAME_PHYSICIAN'),
            value: 'physician.firstname',
            width: '300px',
            sortable: true,
            filterable: true
          },
          {
            text: this.$t('COMPONENT_ACCOUNT.LANR'),
            value: 'physician.lanr',
            sortable: true,
            width: '100px'
          },
          {
            text: this.$t('COMPONENT_ACCOUNT.IKNR'),
            value: 'physician.iknr',
            sortable: true,
            width: '100px'
          },
          {
            text: this.$t('LIST_DIVERSE.COUNT_PATIENTS'),
            value: 'patients',
            class: 'text-center',
            bodyClass: 'text-center',
            sortable: true,
            width: '150px'
          },
          {
            text: this.$t('LIST_DIVERSE.COUNT_REPORT_FORMS'),
            value: 'forms',
            class: 'text-center',
            bodyClass: 'text-center',
            sortable: true,
            width: '150px'
          },
          {
            text: this.$t('LIST_DIVERSE.COUNT_REPORTS'),
            value: 'reports',
            class: 'text-center',
            bodyClass: 'text-center',
            sortable: true,
            width: '150px'
          },
          {
            text: '',
            value: 'data-table-expand',
            sticky: 'right',
            width: '50px'
          }
        ]
      },
    }
  },
  watch: {
    '$route' (to) {
      if (to.name === 'Statistics') {
        this.getDataForTable()
      }
    },

    datesHaveChanged (newValue, oldValue) {
      // give validation time to validate and set correct valid-flag
      setTimeout(() => {
        if (newValue !== oldValue && this.$refs['startDate']?.flags && this.$refs['startDate']?.flags.valid && this.$refs['endDate']?.flags && this.$refs['endDate']?.flags.valid) {
          // set flag for masterDetail to prevent request, when dates are invalid
          this.datesAreInvalid = false
          this.getDataForTable()
        } else {
          this.datesAreInvalid = true
        }
      }, 0)
    }
  },
  components: {
    StatisticsList,
    LxPagination
  },
  created () {
    this.getDataForTable()
  },
  mounted () {
    const tC = this.$refs.Statistics
    this.windowW = tC.clientWidth - 20

    window.addEventListener('resize', () => {
      this.windowW = tC.clientWidth - 20
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', null)
  },
  computed: {
    datesHaveChanged () {
      // initialize watchGroup with two props, for better possibility to compare join elements to string
      return [this.startDate, this.endDate].join()
    }
  },
  methods: {
    /**
     * React on changes of options in lx-data-table, set table-options in component and call getDataForTable
     */
    changeTableOptions (value) {
      if (value) {
        this.tableObj.options = value
      }
      this.getDataForTable()
    },

    /**
     * Localize information to count of reports and their content
     */
    setHeaderMessage () {
      const activity = this.reports > 1 ? this.$t('STATISTICS.WAS_MULTI') : this.$t('STATISTICS.WAS_SINGLE')
      const report = this.reports > 1 ? this.$t('STATISTICS.REPORT_MULTI') : this.$t('STATISTICS.REPORT_SINGLE')
      const forms = this.reportedForms > 1 ? this.$t('STATISTICS.FORM_MULTI') : this.$t('STATISTICS.FORM_SINGLE')

      return this.$t('STATISTICS.TEXT_PART', { countReports: this.reports, countPatients: this.patients, countForms: this.reportedForms, activity: activity, report: report, forms: forms })
    },

    /**
     * Wird verschiedenen Stellen aus aufgerufen und soll die Daten vom Backend abholen. Mittels axios....bla bla bla
     * Besonderheit:
     * "this.pagingOptions.count = res.data.count"
     * - Anzahl der Datensätze vom Server wird auch in den pagingOptions gespeichert
     *
     * **/
    getDataForTable (options) {
      if (this.tableObj.loading) return
      this.tableObj.loading = true

      // reset grid
      this.statisticItems = []
      this.reports = null
      this.patients = null
      this.reportedForms = null

      if (options && typeof options.skip === 'number') {
        this.pagingOptions.skip = options.skip
      }
      if (options && options.limit) {
        this.pagingOptions.limit = options.limit
      }

      let opts = {
        skip: this.pagingOptions.skip,
        limit: this.pagingOptions.limit
      }

      if (this.tableObj.options && this.tableObj.options.sortBy && this.tableObj.options.sortBy.length > 0) {
        opts.sort = {}
        opts.sort[this.tableObj.options.sortBy[0]] = this.tableObj.options.sortDesc[0] ? -1 : 1
      }

      let query = {}

      if (this.startDate) {
        query.startDate = this.startDate
      }

      if (this.endDate) {
        query.endDate = this.endDate
      }

      this.$http.get('/statistics/getOverview?config={"opts":' + JSON.stringify(opts) + ', "query": ' + JSON.stringify(query) + '}')
        .then(res => {
          if (res.data) {
            this.reports = res.data.reports || 0
            this.patients = res.data.patients || 0
            this.reportedForms = res.data.forms || 0
            this.statisticItems = []
            this.pagingOptions.count = res.data.count || 0

            if (Array.isArray(res.data.items)) {
              this.statisticItems = res.data.items
            }

          }
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.tableObj.loading = false
        })
    }
  }
}
</script>
